// Onglet « 📋 Mes tâches » (admin-only) — CONTENEUR.
// Sélecteur de SOUS-ONGLETS : « Tâches » (kanban perso, LOT 1) et « Notes »
// (placeholder — le composant NotesPanel sera fourni par le LOT 3 et branché
// ici par le main-loop ; voir l'emplacement balisé ci-dessous).

import { useState } from 'react'
import { ListChecks, StickyNote } from 'lucide-react'
import { DS } from '../lib/ui'
import MesTachesKanban from './mes-taches/MesTachesKanban'
import NotesPanel from './mes-taches/NotesPanel'

const SUBTABS = [
  { id: 'taches', label: 'Tâches', Icon: ListChecks },
  { id: 'notes', label: 'Notes', Icon: StickyNote },
]

export default function MesTachesTab({ cfg }) {
  const [subTab, setSubTab] = useState('taches') // 'taches' | 'notes'

  return (
    <div>
      {/* Bascule Tâches | Notes — segmented, actif marine. */}
      <div
        style={{
          display: 'inline-flex', gap: 3, marginBottom: 18,
          background: DS.card, border: `0.5px solid ${DS.border}`, borderRadius: 11, padding: 3,
        }}
      >
        {SUBTABS.map(t => {
          const on = subTab === t.id
          return (
            <button
              key={t.id}
              type="button"
              onClick={() => setSubTab(t.id)}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: 7,
                fontSize: 13.5, fontWeight: 600, fontFamily: DS.fontBody,
                padding: '8px 16px', borderRadius: 8, border: 'none', cursor: 'pointer',
                background: on ? DS.marine : 'transparent',
                color: on ? '#fff' : DS.textSecondary,
              }}
              data-testid={`mes-taches-subtab-${t.id}`}
            >
              <t.Icon size={15} strokeWidth={2} /> {t.label}
            </button>
          )
        })}
      </div>

      {subTab === 'taches' && <MesTachesKanban cfg={cfg} />}

      {subTab === 'notes' && <NotesPanel cfg={cfg} />}
    </div>
  )
}
